import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './pages/style.css';

import Home from './pages/Home';
import Footer from './components/Footer/Footer';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import CasesPage from './pages/CasesPage';
import MetaUpdater from './components/MetaUpdater';

const App = () => {
  return (
    <Router>
      <MetaUpdater />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/cases" element={<CasesPage />} />
        <Route path="/about" element={<AboutPage />} />
      </Routes>

      <Footer />
    </Router>
  );
};

export default App;
